import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import propTypes from 'prop-types';
import lang from '../../lang';


import { createFetch } from '../../utils';
const { URL_PREFIX } = window;

class ConfirmResetPassword extends React.Component {
    constructor() {
        super();
        this.state = {
            newPassword: '',
            newPasswordRepeat: '',
            oldPassword: '',
            loading: false,
        };
        this.resetPassword = this.resetPassword.bind(this);
    }
    componentWillMount() {
    }

    async resetPassword() {
        const { linkId } = this.props.match.params;
        const { newPassword, newPasswordRepeat, oldPassword } = this.state;
        const { user } = this.props;
        if (this.state.loading) return;
        try {
            if (newPassword !== newPasswordRepeat) throw new Error(lang.resetPassword.notEqualPassword);
            const result = await createFetch({
                path: user.accessToken ? 'users/me/password' : 'auth/confirm-reset-password',
                method: user.accessToken ? 'PATCH' : 'POST',
                accessToken: user.accessToken,
                body: {
                    password: newPassword,
                    newPassword,
                    linkId,
                    oldPassword,
                },
            });
            if (result.status === 200) {
                await Swal.fire({
                    title: lang.common.success,
                    text: lang.serverMessage[result.message] || result.message,
                    type: 'success',
                });
                if (user.accessToken === null) this.props.history.replace(`${URL_PREFIX}/login`);
                this.props.history.replace(`${URL_PREFIX}`);
            }
            if (result.status === 400) {
                const errorMessage = result.validation.map((o, index) => `${index + 1}. ${lang.serverMessage[o.msg] || o.msg}`);
                throw new Error(errorMessage.join('<br />'));
            }
        } catch (error) {
            this.setState({ loading: false });
            Swal.fire({
                title: lang.titleError,
                // text: error.message,
                html: `<p style="font-size: 14px" class="error-message">${error.message}</p>`,
                type: 'error',
            });
        }
    }

    render() {
        const { newPassword, newPasswordRepeat, loading, oldPassword } = this.state;
        const { user } = this.props;
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[.$@$!%*#?&])[A-Za-z\d.$@$!%*#?&]{8,}$/i;

        return (
            <div style={{ height: user.accessToken === null ? 'auto' : '100vh' }} >
                { user.accessToken === null ? <img src={require('../../static/img/logo-gems.png')} alt="logo-gems" style={{ position: 'absolute', left: 10, top: 10 }} /> : null }
                <div className="reset-password" id="resetPassword">
                    { user.accessToken === null ? <img src={require('../../static/img/logo-wakatobi.svg')} alt="logo-wakatobi" /> : null }
                    <h1>Reset Password</h1>
                    <p>
                        Please set your password according to the rules below:
                    </p>
                    <ol>
                        <li>At least One character</li>
                        <li>At least One special character</li>
                        <li>At least One numeric character</li>
                        <li>Minimum 8 characters</li>
                    </ol>
                    {user.accessToken === null ? null :
                        (
                            <div className="input-group">
                                <p>{lang.resetPassword.oldPassword}</p>
                                <input value={oldPassword} type="password" className="form-control" onChange={e => this.setState({ oldPassword: e.target.value })} />
                            </div>
                        )}
                    <div className="input-group">
                        <p>
                            {lang.resetPassword.newPassword}&nbsp;&nbsp;&nbsp;
                            {passwordRegex.test(newPassword) ?
                                <i className="fa fa-check-circle" style={{ color: '#0f0', fontSize: 18 }} /> :
                                <i className="fa fa-times-circle" style={{ color: '#f00', fontSize: 18 }} />}
                        </p>
                        <input value={newPassword} type="password" className="form-control" onChange={e => this.setState({ newPassword: e.target.value })} />
                    </div>
                    <div className="input-group">
                        <p>
                            {lang.resetPassword.newPasswordRepeat}&nbsp;&nbsp;&nbsp;
                            {newPassword === newPasswordRepeat && passwordRegex.test(newPasswordRepeat) ?
                                <i className="fa fa-check-circle" style={{ color: '#0f0', fontSize: 18 }} /> :
                                <i className="fa fa-times-circle" style={{ color: '#f00', fontSize: 18 }} />}
                        </p>
                        <input value={newPasswordRepeat} type="password" className="form-control" onChange={e => this.setState({ newPasswordRepeat: e.target.value })} />
                    </div>
                    <div className="flex button-space">
                        <Link disabled={loading} to={`${URL_PREFIX}/login`} className="btn btn-alternate">
                            <i className="fa fa-arrow-left" /> {lang.common.cancel}
                        </Link>
                        <button disabled={loading || (newPassword !== newPasswordRepeat || !passwordRegex.test(newPasswordRepeat))} className="btn btn-warning" onClick={this.resetPassword}>
                            <i className="fa fa-sync" />  {lang.resetPassword.btnResetPwd}
                        </button>
                    </div>
                </div>
                { user.accessToken === null ?
                    <div style={{ position: 'absolute', left: 10, bottom: 10 }}>
                        <p style={{ fontSize: 20 }}>Powered by <img src={require('../../static/img/logo-interaktiv.png')} alt="interaktiv.sg" /></p>
                    </div> : null}
            </div>
        );
    }
}

ConfirmResetPassword.propTypes = {
    history: propTypes.object.isRequired,
    match: propTypes.object.isRequired,
    user: propTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
});


export default connect(mapStateToProps, mapDispatchToProps)(ConfirmResetPassword);
